import apiClient, { handleApiError } from '../lib/api-client';
import { API_ENDPOINTS } from '../config/api';

export interface CreateActivityDto {
  activityType: string;
  durationMinutes: number;
  caloriesBurnt?: number;
  distanceKm?: number;
  intensity?: string;
  notes?: string;
  date?: string;
}

export const activitiesService = {
  async list(params?: { startDate?: string; endDate?: string; limit?: number }) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ACTIVITIES.LIST, { params });
      const data = response.data?.data ?? response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },

  async create(dto: CreateActivityDto) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.ACTIVITIES.CREATE, dto);
      return response.data?.data ?? response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },
};
